module.exports = __webpack_public_path__ + "img/et.e24b6ca0.svg";